(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ProfileCriterionDetailController', ProfileCriterionDetailController);

    ProfileCriterionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProfileCriterion', 'ProfileCriterionItem'];

    function ProfileCriterionDetailController($scope, $rootScope, $stateParams, previousState, entity, ProfileCriterion, ProfileCriterionItem) {
        var vm = this;

        vm.profileCriterion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:profileCriterionUpdate', function(event, result) {
            vm.profileCriterion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
